<template>
    <section id="lesson">
        <h3 class="section-title">
            Lessons
        </h3>
        <div
            v-if="$auth.check('lm_lessons.create')"
            class="page-section"
        >
            <el-button
                type="primary"
                icon="plus"
                @click="$router.push({name: 'lessons.add', params: {lm_id: $route.params.lm_id, chapter_id: $route.params.chapter_id}})"
            >
                Add lesson
            </el-button>
        </div>
        <draggable
            v-loading="lessonsLoading"
            :list="lessons"
            item-key="_id"
            class="learning-module__table"
            handle=".learning-module__table-col--handle"
            @start="dragging = true"
            @end="updateItemOrder"
        >
            <template #item="{ element }">
                <el-row
                    :gutter="20"
                    class="learning-module__table-row"
                    align="middle"
                    justify="space-between"
                >
                    <el-col
                        :xs="2"
                        :sm="1"
                        class="learning-module__table-col learning-module__table-col--handle"
                    >
                        <i class="fa fa-align-justify" />
                    </el-col>
                    <el-col
                        :xs="22"
                        :sm="8"
                        class="learning-module__table-col learning-module__table-col--title"
                    >
                        {{ element.title }}
                    </el-col>
                    <el-col
                        :xs="24"
                        :sm="9"
                        class="learning-module__table-col learning-module__table-col--description"
                    >
                        {{ cutString(element.transcript) }}
                    </el-col>
                    <el-col
                        :xs="24"
                        :sm="6"
                        class="learning-module__table-col learning-module__table-col--buttons"
                    >
                        <el-button
                            v-if="$auth.check('lm_lessons.edit')"
                            size="small"
                            icon="edit"
                            @click="$router.push({name: 'lessons.edit', params: {lm_id: $route.params.lm_id, chapter_id: $route.params.chapter_id, lesson_id: element._id}})"
                        >
                            Edit
                        </el-button>
                        <el-button
                            v-if="$auth.check('lm_lessons.delete')"
                            type="danger"
                            size="small"
                            icon="delete"
                            @click="handleDelete(element)"
                        >
                            Delete
                        </el-button>
                    </el-col>
                </el-row>
            </template>
        </draggable>

        <el-pagination
            v-model:current-page="page"
            v-model:page-size="per_page"
            :total="total"
            :page-sizes="[5, 15, 30]"
            hide-on-single-page
            layout="sizes, prev, pager, next, ->, total"
            class="el-pagination--align-right"
            @current-change="fetchData"
            @size-change="fetchData"
        />
    </section>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import draggable from 'vuedraggable'
import { ElMessage, ElMessageBox } from 'element-plus'
import lessonApi from '../../lessonApi'
import {useRoute} from 'vue-router'

const page = ref(1)
const per_page = ref(5)
const total = ref(0)
const route = useRoute()

const lessonsLoading = ref(false)
const lessons = ref(null)

onMounted(() => fetchData())

async function fetchData() {
    lessonsLoading.value = true
    const params = {
        page: page.value,
        limit: per_page.value,
    }

    const {data} = await lessonApi.all(route.params.chapter_id, params)
    lessons.value = data.data
    total.value = data.total
    per_page.value = data.per_page
    lessonsLoading.value = false
}

function handleDelete(row) {
    ElMessageBox.confirm('This will permanently delete the lesson. Continue?', 'Warning', {
        type: 'warning'
    }).then(() => {
        lessonApi.destroy(row._id).then((response) => {
            ElMessage.success( 'Deleted successfully')
            fetchData()
        })
    })
}

const applySearch = _.debounce( function() {
    fetchData()
}, 300)

const dragging = ref(false)

function updateItemOrder() {
    let items = lessons.value.map(function(element, index) {
        return { id: element._id, priority: index }
    })
    lessonApi.priority(items).then(response => {
        if(response.data.success) {
            ElMessage.success( 'Saved successfully')
        }
    }).finally(() => dragging.value = false)
}

const cutString = (str) => _.truncate(str, {'length': 24})
</script>
